module.exports = __webpack_public_path__ + "img/symbol_18.5f72b53d.png";